import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "valeurs",
  class: "screen secondary"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = { class: "grid-3" }
const _hoisted_6 = { class: "panel" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel" }

import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import IconEar from "@/components/icons/IconEar.vue";
import IconMind from "@/components/icons/IconMind.vue";
import IconInovation from "@/components/icons/IconInovation.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionValeurs',
  setup(__props) {

const clickHandler = (origin: string, destination: string) => {
    trackButtonClick(`values-${origin}-${destination}`);
    scrollToSection(destination);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CommonShapeAnimation, {
      shape: "circle",
      position: "right"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Nos valeurs", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", null, "Nos valeurs sont là pour façonner des collaborations authentiques et inspirantes, où vos idées prennent vie. Envie de bâtir une histoire qui vous ressemble ?", -1)),
          _createElementVNode("a", {
            id: "values-header-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler('header', 'contact'))),
            title: "Contactez-nous"
          }, [
            _createVNode(CommonButton, {
              color: "secondary",
              size: "large",
              icon: "next"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Je me lance", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("article", _hoisted_6, [
            _createElementVNode("header", null, [
              _createVNode(IconEar),
              _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Écoute", -1))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "L’écoute, première pierre de la réussite.")
            ], -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "grow" }, "Comprendre vos attentes, vos ambitions et vos défis est la clé d’un projet réussi. Notre approche collaborative transforme vos idées en véritables inspirations.", -1)),
            _createElementVNode("a", {
              id: "values-listen",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandler('listen', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_7, [
            _createElementVNode("header", null, [
              _createVNode(IconMind),
              _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Créativité", -1))
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Imaginer au-delà des limites.")
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "grow" }, "Nous transformons vos idées en concepts uniques et audacieux. Notre mission : innover avec élégance pour faire émerger des projets qui marquent les esprits et se démarquent de l’ordinaire.", -1)),
            _createElementVNode("a", {
              id: "value-create",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (clickHandler('create', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("article", _hoisted_8, [
            _createElementVNode("header", null, [
              _createVNode(IconInovation),
              _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Innovation", -1))
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Rester en avance pour ouvrir de nouvelles perspectives.")
            ], -1)),
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "grow" }, "Nous adoptons les dernières technologies et tendances pour réinventer les codes. Parce qu’être innovant, c’est offrir plus qu’une solution : c’est ouvrir la voie à de nouvelles opportunités.", -1)),
            _createElementVNode("a", {
              id: "value-innovate",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (clickHandler('innovate', 'contact'))),
              title: "Contactez-nous"
            }, [
              _createVNode(CommonButton, { icon: "next" }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("Je me lance", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})